<span class="copy-field">
  <span class="copy-field__text">{{ value }}</span>

  <ng-container *ngIf="value && value !== '-' && value !== 'Procesando'">
    <button
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      class="copy-field__button"
      [class.copy-field__button--copied]="isCopied"
      (click)="onCopy($event)"
    >
      <i class="pi" [ngClass]="isCopied ? 'pi-check-circle' : 'pi-copy'"></i>
    </button>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isCopied"
      [cdkConnectedOverlayPositions]="overlayPositions"
      cdkConnectedOverlayPanelClass="copy-field__overlay-panel"
    >
      <span class="copy-field__tooltip">Copiado</span>
    </ng-template>
  </ng-container>
</span>
